import { useStore } from '../../../store';

export async function authenticatedFetch(
  url: RequestInfo | URL,
  options: RequestInit = {}
): Promise<Response> {
  // Add auth header if token exists
  const accessToken = localStorage.getItem('accessToken');
  const headers = new Headers(options.headers);
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  // Add workspace ID header if available
  const store = useStore.getState();
  const workspaceId = store.getSelectedWorkspaceId();
  if (workspaceId) {
    headers.set('x-workspaceid', workspaceId.toString());
  }

  // Make the initial request
  const response = await fetch(url, {
    ...options,
    headers,
  });

  // Handle 401 Unauthorized
  if (response.status === 401 && !String(url).includes('/api/auth/refresh')) {
    try {
      const refreshToken = localStorage.getItem('refreshToken');

      // Attempt to refresh the token
      const refreshResponse = await fetch('/api/auth/refresh', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: refreshToken }),
      });

      if (!refreshResponse.ok) {
        throw new Error('Token refresh failed');
      }

      const { accessToken: newAccessToken, refreshToken: newRefreshToken } = await refreshResponse.json();

      // Store new tokens
      localStorage.setItem('accessToken', newAccessToken);
      localStorage.setItem('refreshToken', newRefreshToken);

      // Retry original request with new token
      headers.set('Authorization', `Bearer ${newAccessToken}`);
      return fetch(url, {
        ...options,
        headers,
      });
    } catch (error) {
      // Clear tokens and redirect to login on refresh failure
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/login';
      throw error;
    }
  }

  return response;
}
